export const getAssemblyTypeLabel = (type?: string): string => {
  switch (type) {
    case 'ordinary':
      return 'Ordinaria';
    case 'extraordinary':
      return 'Extraordinaria';
    case 'informative':
      return 'Informativa';
    case 'budget':
      return 'Presupuesto';
    case 'special':
      return 'Especial';
    default:
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'No definido';
  }
};

export const getAssemblyStatusLabel = (status?: string): string => {
  switch (status) {
    case 'draft':
      return 'Borrador';
    case 'scheduled':
      return 'Programada';
    case 'in_progress':
      return 'En Progreso';
    case 'completed':
      return 'Completada';
    case 'cancelled':
      return 'Cancelada';
    default:
      return status ? status.charAt(0).toUpperCase() + status.slice(1) : 'No definido';
  }
};

export const getAssemblyStatusBadgeClass = (status?: string): string => {
  switch (status) {
    case 'scheduled':
      return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'in_progress':
      return 'bg-green-50 text-green-700 border-green-200';
    case 'completed':
      return 'bg-gray-50 text-gray-700 border-gray-200';
    case 'cancelled':
      return 'bg-red-50 text-red-700 border-red-200';
    case 'draft':
      return 'bg-amber-50 text-amber-700 border-amber-200';
    default:
      return 'bg-gray-50 text-gray-500 border-gray-200';
  }
};

export const getAssemblyStatusIconClass = (status?: string): string => {
  switch (status) {
    case 'scheduled':
      return 'text-blue-600';
    case 'in_progress':
      return 'text-green-600';
    case 'completed':
      return 'text-gray-600';
    case 'cancelled':
      return 'text-red-600';
    case 'draft':
      return 'text-amber-600';
    default:
      return 'text-gray-400';
  }
};

export const getAssemblyModalityLabel = (isVirtual?: boolean): string => {
  return isVirtual ? 'Virtual' : 'Presencial';
};
